import React, { useEffect, useState } from "react";
import theme from "../../Styles/theme";
import Modal from "react-modal";
import { ModalDivX } from "../ModalDivX";
import { Button, ButtonDiv, Container, Text } from "./styles";

import api from "../../Services/api";
import { useCartorio } from "../../Hooks/cartorio";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";
import { IPrefeitura, usePrefeitura } from "../../Hooks/usePrefeitura";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  item: IPrefeitura;
}
interface ILigacao {
  ID: number;
  PREFEITURA_ID: number;
  CARTORIO_ID: number;
  STATUS: string;
}

export function AddLigacaoPrefeitura({ open, item, onClose }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ title: "", message: "" });
  const { cartorio } = useCartorio();
  const { handleAddPrefeitura } = usePrefeitura();
  function defineText() {
    if (item.STATUS == null || item.STATUS.trim().toUpperCase() == "I") {
      return (
        <>
          <Text>Deseja fazer uma ligação com {item.NOME}?</Text>
          <ButtonDiv>
            <Button onClick={() => onClose()}>Cancelar</Button>
            <Button
              onClick={async () => {
                try {
                  setLoading(true);
                  const { data } = await api.post<ILigacao>(`/ligacao`, {
                    PREFEITURA_ID: item.ID,
                    STATUS: "P",
                    CARTORIO_ID: cartorio.ID,
                  });

                  handleAddPrefeitura(item, {
                    ID: item.ID,
                    NOME: item.NOME,
                    STATUS: data.STATUS,
                    LIGACAO_ID: data.ID,
                  });
                  item.LIGACAO_ID = data.ID;
                  item.STATUS = data.STATUS;
                  onClose();
                } catch (error) {
                  setError({
                    title: "Não foi possível criar uma ligação!",
                    message: `Não foi possível criar uma ligação com ${item.NOME}, tente novamente mais tarde!`,
                  });
                } finally {
                  setLoading(false);
                }
              }}
            >
              Confirmar
            </Button>
          </ButtonDiv>
        </>
      );
    }
    if (item.STATUS != null && item.STATUS.trim().toUpperCase() == "P") {
      return (
        <>
          <Text>Sua ligação com {item.NOME} ainda esta pendente!</Text>

          <ButtonDiv>
            <Button
              onClick={async () => {
                try {
                  setLoading(true);

                  const { data } = await api.delete(
                    `/ligacao/${item.LIGACAO_ID}`
                  );
                  item.LIGACAO_ID = 0;
                  item.STATUS = "I";
                  onClose();
                } catch (error) {
                  setError({
                    title: "Não foi possível cancelar a solicitação!",
                    message:
                      "Não foi possível cancelar a solicitação, tente mais tarde!",
                  });
                } finally {
                  setLoading(false);
                }
              }}
            >
              Cancelar Solicitação
            </Button>
          </ButtonDiv>
        </>
      );
    }

    if (item.STATUS != null && item.STATUS.trim().toUpperCase() == "A") {
      return <Text>Você já possui uma ligação com {item.NOME}!</Text>;
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ModalDivX execute={onClose} />
        {defineText()}
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
